import axios from "axios";
import authHeader from "@/services/auth-header";

class FileDataService {
  updateFileData(fileData, fileDataId) {
    return axios
      .put(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/FileData/${fileDataId}`,
        fileData,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  getFileDataDetail(loanNumber, option) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/FileData/Detail?loanNumber=${loanNumber}&option=${option}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  getPipeline() {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/FileData/Pipeline`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  getDashboardLoanStatus() {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/FileData/Dashboard/LoanStatus`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  getConditionPipeline(pipelineFilter) {
    return axios
      .post(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/FileData/Condition/Pipeline`,
        pipelineFilter,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  getLoanNumbers() {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/FileData/LoanNumbers`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  getLoanStageStatus(loanNumber) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/FileData/LoanStageStatus?loanNumber=${loanNumber}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new FileDataService();
